import { Environment } from "./urls";

const ga_push = (event, category, action, label) => {
  var data = {
    event: event,
    Category: category,
    Action: action,
    Label: label,
  };
  if (window.dataLayer) {
    window.dataLayer.push(data);
  }
  if (
    window.location.href.includes("localhost") ||
    window.location.href.includes("qa")
  ) {
    console.log(data);
  }
};
const vPush = (url, title) => {
  var data = {
    event: "virtualPageview",
    virtualPageURL: url
      ? window.location.origin + window.location.pathname + url
      : window.location.pathname,
    virtualPageTitle: title ? title : window.document.title,
  };
  if (window.dataLayer) {
    window.dataLayer.push(data);
    if (Environment().isLocalhost || Environment().isQA) {
      console.log(data);
    }
    
  }
};
export { ga_push, vPush };
